type Address = {
  street: string;
  number: number;
  appendix: string | undefined;
  city: string;
  postalCode: string;
  [key: string]: unknown;
};

export function formatAddress(address: Address): string {
  const appendix = address.appendix ? ` ${address.appendix}` : '';
  return `${address.street} ${address.number}${appendix}, ${address.postalCode} ${address.city}`;
}
